import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Placeholder from 'flarum/common/components/Placeholder';
import Stream from 'flarum/common/utils/Stream';
import TypeFactory from '../types/TypeFactory';
import sortFields from '../../common/utils/sortFields';
export default class ProfilePane extends Component {
  answers = [];
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  view() {
    const fields = sortFields(app.store.all('masquerade-fields')).filter(field => field.canView() || this.attrs.user.id() === app.session.user?.id()).map(field => {
      const answer = this.answers.find(a => a.field()?.id() === field.id());
      return this.field(field, answer?.content() || null);
    }).filter(field => field !== null);
    return m("div", {
      class: "Masquerade-Bio"
    }, fields.length ? m("div", {
      class: "Fields"
    }, fields) : m(Placeholder, {
      text: app.translator.trans('fof-masquerade.forum.profile.empty-text')
    }));
  }
  field(field, content) {
    const type = TypeFactory.typeForField({
      field,
      stream: Stream(content || '')
    });
    return type.answerField();
  }
  async load() {
    const userId = this.attrs.user.id();
    if (!userId) return;
    const answers = this.attrs.user.masqueradeAnswers();
    if (answers) {
      this.answers = answers;
      return;
    }
    this.answers = [];
    app.store.find('users', userId, {
      include: 'masqueradeAnswers'
    }).then(() => {
      this.answers = this.attrs.user.masqueradeAnswers() || [];
      m.redraw();
    });
  }
}
flarum.reg.add('fof-masquerade', 'forum/panes/ProfilePane', ProfilePane);